module.exports = __webpack_public_path__ + "ceo.jpg?c99ff210df0ea9fdf7f01b2e96531a5e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ceo.jpg
// module id = 465
// module chunks = 0